import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Order from "../../entity/insurance/Order";

const SERVICE = "service-insurance";
const ENTITY = "orders";

export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new Order(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec(useCache = true) {
                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application", false, useCache);
                }
            }
        }
    }
}
